module.exports = __webpack_public_path__ + "static/media/Desocialekaart.2ed593c0.svg";